import Vue from 'vue'
import VueCookies from 'vue-cookies'
import { isString } from '~/util/validators/baseComponentsValidators'

export const STORAGE_SERVICE = {
  PROMO_CODE: 'promoCode',
}

if (typeof window !== 'undefined') {
  Vue.use(VueCookies)
}

export class BaseStorageService {
  getStorage() {
    return this.storage || Vue.$cookies
  }

  setStorage(storage) {
    this.storage = storage
  }

  getItem(key) {
    return this.getStorage() && this.getStorage()
      .get(key)
  }

  setItem(key, value, expireDate = null, secure = null, sameSite = null) {
    const path = '/'
    const domain = null

    return this.getStorage()
      ?.set(key, value, expireDate, path, domain, secure, sameSite)
  }

  removeItem(key) {
    return this.getStorage() && this.getStorage()
      .remove(key)
  }

  saveToken(token) {
    const isHttps = window.location.protocol.includes('https')
    const sameSite = isHttps ? 'None' : 'Lax'

    const expDate = new Date()
    expDate.setDate(expDate.getDate() + 59)

    this.setItem('token', token, expDate, isHttps, sameSite)
  }

  removeToken() {
    this.removeItem('token')
  }

  getToken() {
    return this.getItem('token')
  }

  getUtm() {
    return this.getItem('utm')
  }

  getRefCode() {
    return this.getItem('adw_refcode')
  }

  getAdwCode() {
    const encodeCyrillic = (text) => {
      return text.replace(/[А-Яа-яЁё]/g, (match) => encodeURIComponent(match))
    }

    const result = this.getRefCode() || this.getItem('adw_subid') || this.getItem('adw_referer')
      ? `adw_refcode=${this.getRefCode()}&adw_subid=${this.getItem('adw_subid')}&adw_referer=${this.getItem('adw_referer')}`
      : false

    return isString(result) && encodeCyrillic(result)
  }

  removeAdw() {
    this.removeItem('adw_refcode')
    this.removeItem('adw_subid')
    this.removeItem('adw_referer')
  }

  getStagCode() {
    return this.getItem('stag')
  }

  removeUtm() {
    this.removeItem('utm')
  }

  setAffise(affise) {
    this.setItem('affise', affise)
  }

  getAffise() {
    return this.getItem('affise')
  }

  removeAffise() {
    return this.removeItem('affise')
  }

  getPromokey() {
    return this.getItem('promokey')
  }

  setPromokey(val) {
    return this.setItem('promokey', val)
  }

  removePromokey() {
    this.removeItem('promokey')
  }

  setPayout(val) {
    return this.setItem('payout', val)
  }

  getPayout() {
    return this.getItem('payout')
  }

  removePayout() {
    return this.removeItem('payout')
  }

  setIsBonusPayin(val) {
    return this.setItem('is_welcome_bonus', val, '5m')
  }

  getIsBonusPayin() {
    return this.getItem('is_welcome_bonus')
  }
  removeIsBonusPayin() {
    return this.removeItem('is_welcome_bonus')
  }
}
